import { PremiumServicesDebtor } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

type SubscribeShipperInput = {
  referenceId: number;
  debtor: PremiumServicesDebtor;
  servicePackage: string;
};

const useSubscribeShipper = () => {
  const subscribeShipper = useAxios(
    (
      axios,
      signal,
      { referenceId, debtor, servicePackage }: SubscribeShipperInput
    ) => {
      return axios.request<unknown>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/${referenceId}/shipper-premium-services-subscription`,
        data: { servicePackage, debtor },
        method: 'POST',
      });
    },
    { neededOnPageLoad: false }
  );

  return subscribeShipper;
};

export default useSubscribeShipper;
